<template>
  <v-app>
    <v-container style="background: #005C33"
        fill-height fluid>
      <v-row
          align="center"
          justify="center">
        <v-col cols="12" md="3" sm="7">
          <router-view></router-view>
        </v-col>

      </v-row>


    </v-container>
  </v-app>

</template>

<script>
export default {
  name: "َAuth",
  mounted() {
    if (this.$router.currentRoute.name === 'Auth')
      this.$router.push({name: "Register"})
  }

}
</script>

